export default __webpack_public_path__ + "static/media/calendar.b7f759c8.svg";